<template>
  <div :class="modal ? 'vue-dialog' : ''">
    <b-row>
      <b-col v-if="modal ? (xl = '12') : (xl = '6')">
        <b-card class="attribute-tabs">
          <h3 slot="header" class="card-title">
            {{ $t('account.title.login') }}
          </h3>
          <div class="close-btn-holder" @click="closeModal">
            <i class="fas fa-times"></i>
          </div>
          <b-row v-if="!model.pending">
            <b-col xs="12" sm="12" md="6" lg="7" xl="7" class="login-box-wrap">
              <!--              <sign-in></sign-in>-->
              <login-form></login-form>
            </b-col>
            <b-col
              xs="12"
              sm="12"
              md="6"
              lg="5"
              xl="5"
              class="egate-col egate-box-wrap"
            >
              <e-gate-form :id="id"></e-gate-form>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col lg="12"> Prašome palaukti </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import LoginForm from '@account/js/components/modals/LoginForm.vue'
import EGateForm from '@account/js/components/modals/EGateForm'
import LoginForm from '@account/js/components/modals/LoginForm'
export default {
  name: 'AuthDialog',
  components: { LoginForm, EGateForm },
  title: '',
  props: {
    id: {
      type: String,
      default: '',
    },
    modal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isModal: this.modal,
    }
  },
  computed: {
    model() {
      return this.$store.getters['dataAuth']
    },
  },
  methods: {
    closeModal: function () {
      this.$modal.hide('auth-modal')
    },
  },
}
</script>
